import "../Events";

/** @namespace Accounting */
NS("Accounting");

/**
 * Overrides Events class. Additionally emits same prefixes event statically.
 *
 * @class
 * @extends Events
 */
Accounting.Events = Class(Events, /** @lends Accounting.Events.prototype */{
    eventNameSpace: "Accounting.Events",

    getStaticEventName() {
        return [this.eventNameSpace, event].join(':');
    },
    /**
     * @param {string} event
     * @param {Object} [args]
     * @param {boolean} [emitStatic=true] Does emit namespaced event globally
     */
    emit(event, args, emitStatic = true) {
        this.Parent(event, args);

        if (emitStatic) {
            this.Class.emit(this.getStaticEventName(event), { caller: this, ...args });
            Accounting.Events.emit(this.getStaticEventName(event), { caller: this, ...args });
        }

        return this;
    }
});
